import React, { useContext } from "react";
import Can from "../can/Can";
import { AppContext } from "../../App";
import { masterBalance } from "../../rbac-consts";
import MasterBalancesHistoryContainer from "./master/history/MasterBalancesHistoryContainer";

const MasterBalancesHistoryWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={masterBalance.MASTER}
      yes={() => (
        <MasterBalancesHistoryContainer match={match} />
      )}
    />
  );
};

export default MasterBalancesHistoryWrapper;